import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = ['Noche buscando en internet cómo manejar la última crisis sin encontrar nada concreto', 'Tu hijo sin rutinas claras y cada mañana es una batalla nueva', 'La escuela te llama y no sabés qué decirle al maestro ni cómo pedir adaptaciones', 'Explosiones emocionales que no sabés cómo calmar y te dejan agotado/a', 'Sin herramientas para mostrarle a tu hijo su propio progreso', 'Sintiéndote solo/a en esto porque nadie en tu entorno lo entiende', 'Cobrando energía prestada para llegar al fin de semana y empezar el mismo ciclo', 'Fin de semana agotado/a — el lunes volvió a empezar el mismo caos'];
  return <section className="py-20 px-4 bg-slate-900 border-y border-red-500/20 relative overflow-hidden" data-id="element-186">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-red-500/5 blur-[150px] rounded-full pointer-events-none" data-id="element-187" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-188">
        <div className="text-center mb-12" data-id="element-189">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-190">
            <span className="text-red-500" data-id="element-191">🔴</span> ¿CUÁNTAS NOCHES MÁS VAS A
            PERDER ASÍ?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto" data-id="element-192">
            Amás a tu hijo con todo. Pero terminás las noches buscando en Google
            con material que "más o menos sirve" sin saber si lo que hacés está
            bien o lo está empeorando.
            <br data-id="element-193" />
            <br data-id="element-194" />
            <span className="font-bold text-amber-400" data-id="element-195">
              No es falta de amor. Es falta de un sistema.
            </span>
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-950 border border-red-500/20 rounded-2xl p-6 md:p-10 shadow-2xl" data-id="element-196">
          <h3 className="text-2xl font-bold text-white mb-8 text-center flex items-center justify-center gap-3" data-id="element-197">
            <XCircle className="text-red-500 w-8 h-8" data-id="element-198" /> ¿TE IDENTIFICÁS CON
            ESTO?
          </h3>

          <div className="space-y-4" data-id="element-199">
            {pains.map((pain, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 p-4 rounded-xl bg-slate-900/50 border border-slate-800 hover:border-red-500/30 transition-colors" data-id="element-200">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-201" />
                <p className="text-slate-300 font-medium" data-id="element-202">{pain}</p>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-203">
          <p className="text-2xl md:text-3xl font-black text-amber-400" data-id="element-204">
            ¿Y si esta fuera la última noche que pasó así?
          </p>
        </motion.div>
      </div>
    </section>;
}